import {SnackbarContent, CustomContentProps} from "notistack";
import React from "react";
import ErrorOutlineSharpIcon from '@mui/icons-material/ErrorOutlineSharp';



const CustomError = React.forwardRef<HTMLDivElement, CustomContentProps>((props, ref) => {

    const {
        message
    } = props

    return (
        <SnackbarContent ref={ref}>
            <div className="alert alert--danger" style={{minWidth: "250px"}}>
                <div className="alert__prefix">
                    <ErrorOutlineSharpIcon />
                </div>
                <div className="alert__header">{message}</div>
            </div>
        </SnackbarContent>
    )
})

export {CustomError}